export const SUBMISSION_PERIOD_TEMPLATES_BASE =
  "/accountSettings/submissionPeriodTemplates";

export const SUBMISSION_PERIOD_TEMPLATES_PATHS = {
  index: SUBMISSION_PERIOD_TEMPLATES_BASE,
  new: `${SUBMISSION_PERIOD_TEMPLATES_BASE}/new`,
  edit: (formId: string): string =>
    `${SUBMISSION_PERIOD_TEMPLATES_BASE}/${formId}/edit`,
};
